import React, { useState , useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { hasPerm } from "../utils/permission";
import { authFetch } from "../utils/authFetch";
import { usePerm } from "../hooks/usePerm";

function Sidebar() {
    const navigate = useNavigate();
    const { hasPerm, version } = usePerm();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    // const [, force] = useState(0); 

    const [permVersion, setPermVersion] = useState(0);

    useEffect(() => {
      const handler = () => setPermVersion(v => v + 1);
      window.addEventListener("permissions-updated", handler);
      return () => window.removeEventListener("permissions-updated", handler);
    }, []);

    const handleToggleSidebar = () => {
      setSidebarOpen(prev => !prev);
    };

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const perms = JSON.parse(localStorage.getItem("perms") || "[]");
    
    const handleLogout = async () => {
      const token = localStorage.getItem("token");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("perms");

      if (token) {
        try {
          await authFetch(`/api/v1/auth/logout`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
          });
        } catch {}
      }
      navigate("/");
    };

    return (
        
        <>
        {/* <style>{`
    
  `}</style> */}
  
        <div className="sidebar-wrapper" data-simplebar="true">
        
        <div className="sidebar-header">
          <div className>
            {/* <img src="assets/images/Logo1.png" className="logo-icon-2" alt="" /> */}
            <img src="assets/images/Logo1.png" className="img-fluid" alt=""  style={{ width: "80%" }} />
            {/* <img src="https://suvidhaabnk.com/assets/images/fav.png" className="logo-icon-2" alt="" /> */}
          </div>
          <div>
            {/* <h4 className="logo-text">SuvidhaPe</h4> */}
          </div>
          {/* <a href="#" onClick={handleToggleSidebar}  className="toggle-btn ms-auto"> <i className="bx bx-menu" />
          </a> */}
          <button
            onClick={handleToggleSidebar}
            className="toggle-btn ms-auto"
            style={{ background: "none", border: "none" }}
          >
            <i className="bx bx-menu" />
          </button>
        </div>
        {/*navigation*/}
        <ul className="metismenu" id="menu">
          <li>
            {/* <a href="#" className="has-arrow"> */}
            <Link className="nav-link" to="/dashboard">
              <div className="parent-icon icon-color-1"><i className="bx bx-home-alt" />
              </div>
              <div className="menu-title">Dashboard</div>
            </Link>
          </li>
          {/* <li className="menu-label">Web Apps</li> */}
          {hasPerm("scheme_show") && (
          <li>
            <Link className="nav-link" to="/scheme">
              <div className="parent-icon icon-color-2"><i className="bx bx-envelope" />
              </div>
              <div className="menu-title">Scheme</div>
            </Link>
          </li>
          )}
          {hasPerm("services_show") && (
          <li>
            <Link className="nav-link" to="/services">
              <div className="parent-icon icon-color-3"><i className="bx bx-album" />
              </div>
              <div className="menu-title">Services</div>
            </Link>
          </li>
          )}
          {hasPerm("company_profile") && (
          <li className="d-none">
            <Link className="nav-link" to="/company_profile">
              <div className="parent-icon icon-color-4"> <i className="bx bx-conversation" />
              </div>
              <div className="menu-title">Company Profile</div>
            </Link>
          </li>
          )}
          {hasPerm("member_show") && (
          <li>
            <Link className="nav-link" to="/member">
              <div className="parent-icon icon-color-5"><i className="bx bx-archive" />
              </div>
              <div className="menu-title">Members</div>
            </Link>
          </li>
          )} 
          {hasPerm("settlement_onboarding") && (
          <li>
            <Link className="nav-link" to="/Settlement_list">
              <div className="parent-icon icon-color-2"><i className="bx bx-list-ol" />
              </div>
              <div className="menu-title">Settlement List</div>
            </Link>
          </li>
          )}
          {hasPerm("member_show") && (
          <li className="d-none">
            <Link className="nav-link" to="/merchantbank">
              <div className="parent-icon icon-color-6"><i className="bx bx-archive" />
              </div>
              <div className="menu-title">Merchant Bank</div>
            </Link>
          </li>
          )} 
          <li className="d-none">
            <Link className="nav-link" to="/contact_us">
              <div className="parent-icon icon-color-7"><i className="bx bx-group" />
              </div>
              <div className="menu-title">Contatcs</div>
            </Link>
          </li>
          {hasPerm("provider_manager_show") && (
          <li className="d-none">
            <Link className="nav-link" to="/provider">
              <div className="parent-icon icon-color-8"><i className="bx bx-stats" />
              </div>
              <div className="menu-title">Provider</div>
            </Link>
          </li>
          )}
          {hasPerm("settlement_onboarding") && (
          <li>
            <Link className="nav-link" to="/Settlement_Onboarding">
              <div className="parent-icon icon-color-0"><i className="bx bx-user-check" />
              </div>
              <div className="menu-title">Topay Merchant List</div>
            </Link>
          </li>
          )}
          {hasPerm("settlement_onboarding") && (
          <li>
            <Link className="nav-link" to="/settlement_request_list">
              <div className="parent-icon icon-color-1"><i className="bx bx-wallet-alt" />
              </div>
              <div className="menu-title">Topay Settlement Req</div>
            </Link>
          </li>
          )}
          {hasPerm("paymode_manager_show") && (
          <li>
            <Link to="/paymodes">
              <div className="parent-icon icon-color-9"> <i className="bx bx-calendar-check" />
              </div>
              <div className="menu-title">Paymodes</div>
            </Link>
          </li> 
          )}
          {hasPerm("api_token") && (
          <li>
            <Link to="/apitoken">
              <div className="parent-icon icon-color-10"> <i className="bx bx-calendar" />
              </div>
              <div className="menu-title">API Token</div>
            </Link>
          </li>
          )}
          {hasPerm("payout_api_token") && (
          <li>
            <Link to="/payoutapitoken">
              <div className="parent-icon icon-color-11"> <i className="bx bx-star" />
              </div>
              <div className="menu-title">Payout API Token</div>
            </Link>
          </li>
          )}
          {hasPerm("verify_token") && (
          <li>
            <Link to="/verifytoken">
              <div className="parent-icon icon-color-12"> <i className="bx bx-vertical-center" />
              </div>
              <div className="menu-title">Verify API Token</div>
            </Link>
          </li>
          )}
          {/* {hasPerm("funds_menu_show") && ( */}
          {hasPerm("wallet_transfer") && (
          <li>
            <Link to="/wallet_transfer">
              <div className="parent-icon icon-color-1"> <i className="bx bx-transfer" />
              </div>
              <div className="menu-title">Wallet Transfer</div>
            </Link>
          </li>
          )}
          {hasPerm("pan_report") && (
          <li>
            <Link to="/pan_report">
              <div className="parent-icon icon-color-2"> <i className="bx bx-star" />
              </div>
              <div className="menu-title">Pan Reports</div>
            </Link>
          </li>
          )}
          <li>
            <a className="has-arrow" href="#">
              <div className="parent-icon icon-color-3"><i className="bx bx-spa" />
              </div>
              <div className="menu-title">Funds</div>
            </a>
            <ul>
              {/* {hasPerm("funds_load") && ( */}
              <li><Link to="/fund_request"><i className="bx bx-right-arrow-alt" />Load Wallet</Link></li>
              {/* )} */}
              {/* {hasPerm("funds_request") && (
              <li><Link to="request"><i className="bx bx-right-arrow-alt" />Request</Link></li>
              )}
              {hasPerm("funds_report") && (
              <li><Link to="request"><i className="bx bx-right-arrow-alt" />Request Report</Link></li>
              )} */}
            </ul>
          </li>
          {/* )} */}
          {(hasPerm("payin_report") || hasPerm("payout_report")) && (
          <li>
            <a className="has-arrow" href="#">
              <div className="parent-icon icon-color-4"><i className="bx bx-repeat" />
              </div>
              <div className="menu-title">Reports</div>
            </a>
            <ul>
              {hasPerm("payin_report") && (
              <li> <Link to="/payin"><i className="bx bx-right-arrow-alt" />Payin</Link>
              </li>
              )}
              {hasPerm("payout_report") && (
              <li> <Link to="/payout"><i className="bx bx-right-arrow-alt" />Payout</Link>
              </li>
              )}
            </ul>
          </li>
          )}
          {(hasPerm("payout_statement") || hasPerm("payin_statement")) && (
          <li>
            <a className="has-arrow" href="#">
              <div className="parent-icon icon-color-5"> <i className="bx bx-donate-blood" />
              </div>
              <div className="menu-title">A/c Statement</div>
            </a>
            <ul>
              {hasPerm("payout_statement") && (
              <li> <Link to="/mainwallet"><i className="bx bx-right-arrow-alt" />Main Wallet</Link>
              </li>
              )}
              {hasPerm("payin_statement") && (
              <li> <Link to="/payinwallet"><i className="bx bx-right-arrow-alt" />Payin Wallet</Link>
              </li>
              )}
            </ul>
          </li>
          )}
          {hasPerm("funds_menu_show") && (
          <li>
            <a className="has-arrow" href="#">
              <div className="parent-icon icon-color-6"> <i className="bx bx-comment-edit" />
              </div>
              <div className="menu-title">Setup Tools</div>
            </a>
            <ul>
              <li> <Link to="/apis"><i className="bx bx-right-arrow-alt" />Api Manager</Link>
              </li>
              <li> <Link to="/bank"><i className="bx bx-right-arrow-alt" />Bank A/c</Link>
              </li>
              {/* <li> <a href="form-layouts.html"><i className="bx bx-right-arrow-alt" />Portal Setting</a>
              </li> */}
            </ul>
          </li>
          )}
          {hasPerm("role_permission") && (
          <li>
            <a className="has-arrow" href="#">
              <div className="parent-icon icon-color-7"><i className="bx bx-grid-alt" />
              </div>
              <div className="menu-title">Role & Permission</div>
            </a>
            <ul>
              <li> <Link to="/roles"><i className="bx bx-right-arrow-alt" />Role</Link></li>
              <li> <Link to="/permissions"><i className="bx bx-right-arrow-alt" />Permission</Link></li>
            </ul>
          </li>
          )}

          <li>
            <a href="#" onClick={(e) => {e.preventDefault();handleLogout();}}>
              <div className="parent-icon icon-color-8"> <i className="bx bx-power-off " />
              </div>
              <div className="menu-title">Logout</div>
            </a>
          </li>

        </ul>
        
      </div>
      {/* </div> */}
        </>
    )
}

export default Sidebar